module.exports = __webpack_public_path__ + "media/images/ptrn1-9f944dfc8548e76588ab66a5b1c8d06a.png";